export default __webpack_public_path__ + "images/23_1_image.jpg";